import moment, { Moment } from "moment";
import i18n from "./i18n";
import dateTimeHelper from "./app/helpers/dateTimeHelper/dateTimeHelper";

export { }
declare module 'moment' {
    interface Moment {
        asSourceTimeZone(): Moment;
        toSourceTimeZone(): Moment;
        asLocalZone(zone: string): Moment;
    }
}

declare global {
    export interface Number {
        toCurrencyFormat(hideDecimals?: boolean, devideToHundred?: boolean): string;
        toDurationFormat(): string;
    }
    export interface String {
        toCapitilizedFormat(): string;
        toPascalCase(): string;
        interpolateError(): any;
        toFixedApiDateString(): string;
        toDateTimeFormat(): string;
        toDateFormat(): string;
        asSourceTimeZone(): moment.Moment;
        toSourceTimeZone(): moment.Moment;
        asLocalZone(): Moment;
    }
    interface Window {
        config: any;
    }
    interface Window {
        dataLayer: any;
    }


}
var currencyFormatter = new Intl.NumberFormat('sw-SW', {
    style: 'currency',
    currency: 'SEK'
});
Number.prototype.toCurrencyFormat = function (this: number, hideDecimals?: boolean, devideToHundred?: boolean): string {
    let re = /\,/gi;
    if (isNaN(this))
        return "-"
    if (hideDecimals)
        currencyFormatter = new Intl.NumberFormat('sw-SW', {
            style: 'currency',
            currency: 'SEK',
            maximumFractionDigits: 0
        });
    else
        currencyFormatter = new Intl.NumberFormat('sw-SW', {
            style: 'currency',
            currency: 'SEK'
        });
    return currencyFormatter.format(devideToHundred ? this / 100 : this).replace("SEK", "").replace(re, " ").replace(".", ",");
};
Number.prototype.toDurationFormat = function (this: number): string {
    const hours = Math.floor(this / 60);
    const mins = this % 60;

    let result = "";
    if (hours > 0) result += `${hours} hour${hours > 1 ? "s" : ""}`;
    if (mins > 0) result += `${hours > 0 ? " " : ""}${mins} min`;

    return result || "0 min";
};


String.prototype.toCapitilizedFormat = function (this: string): string {
    return this.charAt(0).toUpperCase() + this.slice(1)
}
String.prototype.toPascalCase = function () {
    return this
        .toLowerCase()
        .replace(new RegExp(/[-_]+/, 'g'), ' ')
        .replace(new RegExp(/[^\w\s]/, 'g'), '')
        .replace(
            new RegExp(/\s+(.)(\w*)/, 'g'),
            ($1, $2, $3) => `${$2.toUpperCase() + $3}`
        )
        .replace(new RegExp(/\w/), s => s.toUpperCase());
};
String.prototype.interpolateError = function (this: string) {
    let errorTexts = this.split(/\s*,\s*/);
    if (errorTexts.length === 3) {
        return i18n.t(errorTexts[0], { dynamicValue: errorTexts[1], dynamicValue2: errorTexts[2] });
    } else if (errorTexts.length === 2) {
        return i18n.t(errorTexts[0], { dynamicValue: errorTexts[1] });
    } else if (errorTexts[0] && !errorTexts[0].includes(" ")) {
        return i18n.t(errorTexts[0]);
    }
    else {
        return errorTexts[0];
    }
}

moment.fn.toSourceTimeZone = function (this: Moment) {
    return moment.tz(this, dateTimeHelper.getSourceTimeZone());
}
String.prototype.toSourceTimeZone = function (this: string) {
    const d = new Date(this);
    return moment(d).tz(dateTimeHelper.getSourceTimeZone());
}

String.prototype.toFixedApiDateString = function (this: string) {
    if (!this)
        return "";
    return this.toSourceTimeZone().format("YYYY-MM-DDT00:00+00:00");
}
String.prototype.toDateTimeFormat = function (this: string) {
    if (!this)
        return "";
    return this.toSourceTimeZone().format("YYYY-MM-DD HH:mm");
}
String.prototype.toDateFormat = function (this: string) {
    if (!this)
        return "";
    return this.toSourceTimeZone().format("YYYY-MM-DD");
}

String.prototype.asSourceTimeZone = function (this: string): Moment {
    if (!this) return moment.invalid();
    const localTimeString = moment(this).format("YYYY-MM-DD HH:mm");
    const cetMoment = moment.tz(localTimeString, dateTimeHelper.getSourceTimeZone());
    return cetMoment;
};

moment.fn.asSourceTimeZone = function (this: Moment): Moment {
    if (!this.isValid()) return this;
    const localTimeString = this.format("YYYY-MM-DD HH:mm");
    return moment.tz(localTimeString, dateTimeHelper.getSourceTimeZone());
};

moment.fn.asLocalZone = function (this: Moment) {
    const dateTimeString = this.format("YYYY-MM-DD HH:mm");
    return moment.tz(dateTimeString, moment.tz.guess());
}
String.prototype.asLocalZone = function (this: string) {
    let timeInSourceZone = moment.tz(this, dateTimeHelper.getSourceTimeZone());
    const dateTimeString = timeInSourceZone.format("YYYY-MM-DD HH:mm");
    return moment.tz(dateTimeString, moment.tz.guess());
}